import React from 'react';
import classnames from 'classnames';
import s from './EmptyBackground.scss';

export const EmptyBackground: React.FC<{ className?: string }> = ({
  className,
}) => {
  return <div className={classnames(s['root'], className)} />;
};
EmptyBackground.displayName = 'EmptyBackground';
export default EmptyBackground;
